<script lang="ts">
  import { CostItem } from "@models/costs/CostItem"
  import { Person } from "@models/profiles/Person"
  import { formatCentsAsUsd } from "@util/money"

  export let person: Person
  export let costItems: CostItem[]

  let total = costItems.reduce((acc, costItem) => acc + costItem.cost, 0)
</script>

{#each costItems as costItem}
  <div class="grid grid-cols-3 gap-block-4 mt-1" data-role="cost-item">
    <div class="col-span-2" data-role="description">{costItem.description}</div>
    <div class="text-right" data-role="cost">{formatCentsAsUsd(costItem.cost)}</div>
  </div>
{/each}

<div class="grid grid-cols-3 gap-block-4" data-role="cost-item">
  <div class="col-span-2" data-role="description">Total Trip Cost for {person.firstName}</div>
  <div class="text-right" data-role="cost">{formatCentsAsUsd(total)}</div>
</div>
